const eventos = [
    {
        id : 1,
        nome : 'Tour T4',
        texto : 'Em agosto nosso Tour confirmado! Venha fazer parte dessa competição que já virou tradição.',
        data : '02/08/2020',
        dia: '02',
        imagem : 'https://blog.mapmyrun.com/wp-content/uploads/2019/07/Top-10-Technique-Tips-to-Improve-Your-Cycling-Efficiency-752x472.jpg',
    },
    {
        id : 2         ,
        nome : 'Treinão do 70.3',
        texto : 'Treinão da T4 com fococ nas transições e táticas para o próximo 70.3 no Rio.',
        data : '20/08/2020',
        dia: '20',
        imagem : 'https://ak.picdn.net/shutterstock/videos/26210150/thumb/2.jpg',
    },
]

export default {
    EVENTOS: eventos,
}
